/* eslint-disable no-unused-expressions */
import { cleanProductName } from '~~/utils'

const PIXEL_ID = '408694775992652'

function generatePixel() {
  /* prettier-ignore */
  !function(f,b,e,v,n,t,s)
  {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
  n.callMethod.apply(n,arguments):n.queue.push(arguments)};

  if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
  n.queue=[];t=b.createElement(e);t.async=!0;
  t.src=v;s=b.getElementsByTagName(e)[0];
  s.parentNode.insertBefore(t,s)}(window, document,'script',
  'https://connect.facebook.net/en_US/fbevents.js');
}

export default function ({ app, store, isDev }) {
  generatePixel()

  init(store.state.user.details)
  track('PageView')

  /**
   * TODO: Add events
   * - view-product
   * - checkout
   */
  app.$bus.$on('lead', () => track('Lead'))
  app.$bus.$on('register', () => track('CompleteRegistration'))
  app.$bus.$on('login', user => init(user))
  app.$bus.$on('add-cart', product =>
    track('AddToCart', {
      content_ids: [`${product.id}`],
      content_name: cleanProductName(product.name),
      content_type: 'product',
      currency: 'USD',
      value: product.amount
    })
  )
  app.$bus.$on('trial', () => track('StartTrial'))

  function init(user) {
    const userOptions = user.id
      ? {
          em: user.email,
          fn: decodeURIComponent(user.firstName),
          ln: decodeURIComponent(user.lastName)
        }
      : {}

    window.fbq('init', PIXEL_ID, userOptions)
  }

  function track(eventName, payload = {}) {
    window.fbq('track', eventName, payload)
  }
}
